import AppDataService from "./AppDataService";

const COMMON_BASE = 'ManageExtension'

export default class ManageExtensionDataService {
    static async getFilterData(){
        return await AppDataService.get(`${COMMON_BASE}/GetFormData`);
    }

    static async getGridData(data){
        return await AppDataService.post(`${COMMON_BASE}/GetList`, data);
    }

    static async pdfPreview(params){
        const {formId, UserId} = params;
        return await AppDataService.get(`${COMMON_BASE}/PdfPreview?formId=${formId}&UserId=${UserId}`);
    }

    static async deleteForm(params){
        const { formId } = params;
        return await AppDataService.delete(`${COMMON_BASE}/DeleteForm?formId=${formId}`);
    }

    static async getExtensionAmount(params){
        return await AppDataService.get(`${COMMON_BASE}/GetExtensionAmount`, {params});
    }

    static async extensionPayment(data){
        return await AppDataService.post(`${COMMON_BASE}/ExtensionPayment`, data);
    }
}